'use client';

import { useEffect } from 'react';

export default function ServiceWorkerRegistration() {
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const registerSW = async () => {
      try {
        const registration = await navigator.serviceWorker?.register('/sw.js', {
          scope: '/',
          // updateViaCache: 'none' ensures the browser always checks for SW updates
          // rather than serving the SW script from HTTP cache
          updateViaCache: 'none',
        });

        // Check for updates on page visibility change (user returns to tab)
        // This is better than polling every 60s which wastes battery/data
        const handleVisibilityChange = () => {
          if (document.visibilityState === 'visible') {
            registration?.update()?.catch(() => {
              // Silently ignore update check failures (offline)
            });
          }
        };
        document.addEventListener('visibilitychange', handleVisibilityChange);

        registration?.addEventListener('updatefound', () => {
          const newWorker = registration?.installing;
          if (!newWorker) return;

          newWorker?.addEventListener('statechange', () => {
            if (
              newWorker?.state === 'installed' &&
              navigator.serviceWorker?.controller
            ) {
              // A new service worker is installed and waiting.
              // The new SW will activate on next navigation (skipWaiting is called in install).
              console.log('[SW] New version available — will activate on next page load');
            }
          });
        });

        return () => {
          document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
      } catch (err) {
        console.warn('[SW] Registration failed:', err);
      }
    };

    // Register after page load to not compete with critical resources
    if (document.readyState === 'complete') {
      registerSW();
    } else {
      window.addEventListener('load', registerSW, { once: true });
    }
  }, []);

  return null;
}
